import { CreateOpportunityFlow, OpportunityFlow, UpdateOpportunityFlow } from '@/entities/opportunityFlow';
import { OpportunityFlowWithBusiness } from '@/entities/opportunityFlowWithBusiness';
import { OpportunityFlowService } from '@/services/OpportunityFlowService';
import { useEffect, useState} from 'react';
export function useColabOpportunityFlow() {
  const [opportunityFlows, setOpportunityFlows] = useState<OpportunityFlow[]>([]);
  const [collabOpportunityFlowWithBusienss, setCollabOpportunityFlowWithBusiness] = useState<OpportunityFlowWithBusiness[]>([]);
  const [nextOrder, setNextOrder] = useState<number>(0);

  const getOpportunityFlowWithBusinessbyId = async (companyId: number, userId: number) => {
    const response = await OpportunityFlowService.getOpportunityFlowWithBusinessbyId(companyId,userId)
    if(response){
      return response;
    }
  };

  return {
    collabOpportunityFlowWithBusienss,
    opportunityFlows,
    nextOrder,
    setOpportunityFlows,
    setNextOrder,
    getOpportunityFlowWithBusinessbyId
  };
}
